import {t} from "@lingui/core/macro";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {HeadingLarge} from "@khanacademy/wonder-blocks-typography";

const AccessDenied = (): React.ReactElement => (
    <View>
        <HeadingLarge>
            {t`You do not have access to view this content for this user`}
        </HeadingLarge>
    </View>
);

export default AccessDenied;
